import React, { useEffect } from "react";
import { Button } from "primereact/button";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CouponsTable from "./CouponsTable";
import { getCoupons } from "../../store/AsyncMethods/CouponMethod";

export default function CouponsMain() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.AuthReducer);

  useEffect(() => {
    if (user) {
      dispatch(getCoupons());
    }
  }, []);

  return (
    <div className="mx-3">
      <div className="flex justify-end">
        <Button
          label="Add Coupon"
          icon="pi pi-plus"
          className="p-primary-btn"
          onClick={() => navigate("/add-coupon")}
        />
      </div>

      <div className="my-4">
        <CouponsTable />
      </div>
    </div>
  );
}
